export enum ApplicationStepType {
  JurisdictionPage = 'jurisdiction',
  TechnicalData = 'technicalData',
  PersonalData = 'personalData',
  Documents = 'documents',
}

export interface ApplicationStepsConfiguration {
  currentStep: ApplicationStepType;
  steps: ApplicationStepConfigurationModel[];
}

export interface ApplicationStepConfigurationModel {
  step: ApplicationStepType;
  navigateTo: string;
}
